/* eslint-disable */
import {Injectable} from '@angular/core';
import {BaseSearch, BaseSearchService} from "../base.search-service";
import {UiConstants} from "../../util/core-utils";
import {Order, OrderType} from "../util/services";
import {LoggedInUserStorage} from "../util/storages";
import {ClientDocument} from "../client-document/client-document.service";

/* eslint-enable */

@Injectable()
export class ColonnadeInsuranceSearchService extends BaseSearchService {

  protected createStorage(): ColonnadeInsuranceSearch.Storage {
    return new ColonnadeInsuranceSearch.Storage();
  }

}

export namespace ColonnadeInsuranceSearch {

  export interface SearchDataGetRequest extends BaseSearch.SearchDataGetRequest {
    listIdentifier?: string;
  }

  export interface SearchDataSetRequest extends BaseSearch.SearchDataSetRequest {
    listIdentifier?: string;
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData extends BaseSearch.SearchData {
    order?: Order<ClientDocument.OrderField>;
    dqlText?: string;
  }

  interface StoredSearchRawData extends BaseSearch.StoredSearchRawData {
    order?: Order<ClientDocument.OrderField>;
    dqlText?: string;
  }

  export class Storage extends BaseSearch.Storage {

    constructor() {
      const defaultSearchData: SearchData = {
        itemsPerPage: UiConstants.pageNumbers[0],
        pageNumber: 1,
        order: {
          field: ClientDocument.OrderField.SUBMIT_TIME,
          type: OrderType.DESC
        },
        dqlText: undefined
      };
      /**
       * Increment this version if you change the SearchData interface.
       */
      const versionNumber: number = 1;
      super(defaultSearchData, versionNumber);
    }

    protected generateKey(request: SearchDataGetRequest | SearchDataSetRequest): string {
      return request.listIdentifier
        ? 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-Colonnade-Insurance-List(' + request.listIdentifier + ')'
        : 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-Colonnade-Insurance-Global';
    }

    protected fromRaw(data: StoredSearchRawData): BaseSearch.SearchDataResult {
      const searchData: SearchData = {
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        dqlText: data.dqlText,
      };
      return {
        searchData: searchData
      };
    }

    protected toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: this.VERSION,
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        dqlText: data.dqlText,
      };
    }

  }

}
